import {MutationTree} from "vuex";
import {TemplateParamsState} from "@/store/template_params/types";

export const mutations: MutationTree<TemplateParamsState> = {
    pushTemplateParams: (state, data) => {
        state.templateParams = state.templateParams.concat(data);
    },
    setTemplateParams: (state, data) => {
        state.templateParams = data;
    },
}